import _ from 'lodash';
import objectAssign from 'object-assign';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/memberActions';
import * as clubActions from '../../actions/clubActions';
import { Link, withRouter } from 'react-router';
import * as utils from '../../components/common/utils';
import TextInput from '../../components/common/TextInput';
import CheckboxInput from '../../components/common/CheckboxInput';
import DateInput from '../../components/common/DateInput';
import Loading from '../../components/Loading';
import FontAwesome from 'react-fontawesome';
import toastr from 'toastr';

class ManageMemberPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillMount = this.componentWillMount.bind(this);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    this.shouldUpdateMemberDetails = this.shouldUpdateMemberDetails.bind(this);
    this.deleteMember = this.deleteMember.bind(this);
    this.updateField = this.updateField.bind(this);
    this.updateDateField = this.updateDateField.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.fullName = this.fullName.bind(this);
    this.askBeforeExit = this.askBeforeExit.bind(this);
    let memberDetails = {};
    let errors = {};
    if(props.memberId) {
      memberDetails = objectAssign({}, props.memberDetails);
    } else {
      memberDetails['club'] = props.clubId;
    }
    this.state = {
      memberDetails: memberDetails,
      loadingMembers: false,
      errors: errors,
    };
  }

  componentWillMount() {
    if(this.props.memberId) {
      this.props.actions.loadMemberDetails(this.props.clubId, this.props.memberId);
    }
    this.props.router.setRouteLeaveHook(this.props.route, () => {
      return this.askBeforeExit();
    });
  }

  componentWillReceiveProps(nextProps) {
    if(this.shouldUpdateMemberDetails(nextProps)) {
      this.setState({
        memberDetails: nextProps.memberDetails,
        errors: nextProps.errors,
        loadingMembers: nextProps.loadingMembers,
      });
    } else if(!_.isEqual(this.props.errors, nextProps.errors)) {
      this.setState({
        loadingMembers: false,
        errors: nextProps.errors,
      });
    }
    if (this.props.memberId == undefined && this.state.memberDetails.club == undefined) {
      let memberDetails = objectAssign({}, this.props.memberDetails);
      memberDetails['club'] = this.props.clubId;
      this.setState({
        memberDetails: memberDetails,
        errors: {},
      });
    }
  }

  shouldUpdateMemberDetails(nextProps) {
    let p = this.props;
    let updated = p.memberDetailsUpdated !== nextProps.memberDetailsUpdated;
    return _.every([updated], (item) => item === true);
  }

  deleteMember(e) {
    if (!confirm('Bekreft at du ønsker å slette dette medlemmet')) {
      e.prclubDefault();
      return false;
    }
    this.props.actions.deleteMember(this.props.clubId, this.props.memberId);
  }

  updateField(e) {
    let memberDetails = objectAssign({}, this.state.memberDetails);
    let value = e.target.type == 'checkbox' ? e.target.checked : e.target.value;
    memberDetails[e.target.name] = value;
    return this.setState({
      memberDetails: memberDetails
    });
  }

  updateDateField(field, date) {
    let memberDetails = objectAssign({}, this.state.memberDetails);
    memberDetails[field] = date;
    return this.setState({
      memberDetails: memberDetails
    });
  }

  fullName() {
    let member = this.state.memberDetails;
    if (member.first_name || member.last_name) {
      return member.first_name + ' ' + member.last_name;
    }
  }

  submitForm(e) {
    toastr.info('Lagrer');
    this.setState({
      loadingMembers: true,
    });
    if (this.props.memberId) {
      this.props.actions.updateMember(this.state.memberDetails);
    } else {
      this.props.actions.createMember(this.state.memberDetails);
    }
    e.preventDefault();
  }

  askBeforeExit() {
    let changed = !_.isEqual(this.props.memberDetails, this.state.memberDetails);
    if (this.props.clubId && changed && !confirm('Ønsker du å gå tilbake uten å lagre?')) {
      return false;
    } else {
      return true;
    }
  }

  render() {
    let member = this.state.memberDetails;
    // let address = utils.join([member.address, member.zip,
    //   member.municipality, member.county, member.country], ", ");
    return (
      <div className="member-page-container container">
        <div className="row">
          <div className="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
            <div className="panel panel-default">
              <div className="panel-heading">
                <h2>
                  {this.fullName() || 'Medlem'}
                  <Loading loading={this.props.loadingMembers} />
                </h2>
              </div>
              <div className="panel-body">
                {/*<dl className="dl-horizontal">
                  <dt>Navn:</dt>
                  <dd>{member.first_name + " " + member.last_name}</dd>
                  <dt>Tlf:</dt>
                  <dd>{member.phone_number}</dd>
                  <dt>Epost:</dt>
                  <dd>{member.email}</dd>
                  <dt>Aktiv:</dt>
                  <dd>{member.active ? 'Ja' : 'Nei'}</dd>
                  <dt>Adresse:</dt>
                  <dd>{address}</dd>
                </dl>
                <hr/>
                */}
                <form onSubmit={this.submitForm}>
                  <input type="submit" value="submit" className="hidden"/>
                  <TextInput
                    name="first_name"
                    label="Fornavn *"
                    error={this.state.errors.first_name}
                    placeholder="Fornavn"
                    onChange={this.updateField}
                    value={member.first_name}
                    />
                  <TextInput
                    name="last_name"
                    label="Etternavn *"
                    error={this.state.errors.last_name}
                    placeholder="Etternavn"
                    onChange={this.updateField}
                    value={member.last_name}
                    />
                  <DateInput
                    name="birth_date"
                    label="Fødselsdato *"
                    error={this.state.errors.birth_date}
                    placeholder="Fødselsdato"
                    onChange={this.updateDateField}
                    value={member.birth_date}
                    />
                  {/*
                  <div className="page-header">
                    <h3>Allergier / Vegetarianer</h3>
                  </div>
                  <CheckboxInput
                    name="vegetarian"
                    label="Vegetarianer"
                    error={this.state.errors.vegetarian}
                    onChange={this.updateField}
                    checked={member.vegetarian}
                    value={'_' + member.vegetarian}
                    />
                  <CheckboxInput
                    name="gluten_allergic"
                    label="Glutenallergiker"
                    error={this.state.errors.gluten_allergic}
                    onChange={this.updateField}
                    checked={member.gluten_allergic}
                    value={'_' + member.gluten_allergic}
                    />
                  <CheckboxInput
                    name="lactose_allergic"
                    label="Laktoseintolerant"
                    error={this.state.errors.lactose_allergic}
                    onChange={this.updateField}
                    checked={member.lactose_allergic}
                    value={'_' + member.lactose_allergic}
                    />
                  <CheckboxInput
                    name="nut_allergic"
                    label="Nøttealergi"
                    error={this.state.errors.nut_allergic}
                    onChange={this.updateField}
                    checked={member.nut_allergic}
                    value={'_' + member.nut_allergic}
                    /> */}
                  <div className="page-header">
                    <h3>
                      Kontaktinformasjon
                    </h3>
                  </div>
                  <TextInput
                    name="phone_number"
                    label="Telefonnummer"
                    error={this.state.errors.phone_number}
                    placeholder="Telefonnummer"
                    onChange={this.updateField}
                    value={member.phone_number}
                    />
                  <TextInput
                    name="email"
                    label="Epost"
                    error={this.state.errors.email}
                    placeholder="Epost"
                    onChange={this.updateField}
                    value={member.email}
                    />
                  <TextInput
                    name="address"
                    label="Adresse"
                    error={this.state.errors.address}
                    placeholder="Adresse"
                    onChange={this.updateField}
                    value={member.address}
                    />
                  <TextInput
                    name="zip"
                    label="Postnummer"
                    error={this.state.errors.zip}
                    placeholder="Postnummer"
                    onChange={this.updateField}
                    value={member.zip}
                    />
                  <TextInput
                    name="municipality"
                    label="Region"
                    error={this.state.errors.municipality}
                    placeholder="Region"
                    onChange={this.updateField}
                    value={member.municipality}
                    />
                  <TextInput
                    name="country"
                    label="Land"
                    error={this.state.errors.country}
                    placeholder="Land"
                    onChange={this.updateField}
                    value={member.country}
                    />
                </form>
              </div>
              <div className="panel-footer clearfix">
                <Link className="btn btn-default"
                  to={'/klubb/' + this.props.clubId}>
                  Tilbake
                </Link>
                <span className="pull-right">
                  {this.props.memberId && <button className="btn btn-danger" onClick={this.deleteMember}>
                    <FontAwesome
                      name="trash" />
                    <span className="hidden-xs">{' Slett'}</span>
                  </button>}
                  {' '}
                  <button className="btn btn-primary"
                    disabled={this.state.loadingMembers}
                    onClick={this.submitForm} >
                    <FontAwesome name="save" />
                    {' Lagre'}
                  </button>
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

ManageMemberPage.propTypes = {
  actions: PropTypes.object.isRequired,
  clubActions: PropTypes.object.isRequired,
  clubId: PropTypes.string.isRequired,
  memberId: PropTypes.string,
  memberDetails: PropTypes.object.isRequired,
  clubDetails: PropTypes.object,
  errors: PropTypes.object,
  memberDetailsUpdated: PropTypes.number,
  loadingMembers: PropTypes.bool,
  router: PropTypes.object.isRequired,
  route: PropTypes.object,
};

function mapStateToProps(state, ownProps) {
  return {
    clubId: ownProps.params.clubId,
    memberId: ownProps.params.memberId,
    loadingMembers: state.clubs.loadingMembers,
    memberDetails: state.clubs.memberDetails,
    clubDetails: state.clubs.clubDetails,
    errors: state.clubs.errors,
    memberDetailsUpdated: state.clubs.memberDetailsUpdated,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    clubActions: bindActionCreators(clubActions, dispatch),
  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageMemberPage));



/** WEBPACK FOOTER **
 ** ./src/containers/clubs/ManageMemberPage.js
 **/